
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoayoshyacabpackage() {



    const cardData =
    {
        keyword: 'Pune to Ayodhya Cab Packages ',
        heading: 'Platinum24 Cabs: Pune to Ayodhya Cab Packages',
        headingDescription: ' Platinum24 Cabs provides convenient Pune to Ayodhya cab packages, designed for pilgrims, families, and long-distance travelers. Whether you’re visiting the sacred Shri Ram Janmabhoomi Mandir, attending religious ceremonies, or planning a heritage tour of Ayodhya, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a comfortable and safe journey. With skilled chauffeurs, punctual service, and transparent pricing, we make your pilgrimage stress-free and memorable. From one-way rides to return trip packages, Platinum24 Cabs guarantees dependable service and a pleasant Pune to Ayodhya travel experience for every devotee and traveler.',

        top: 'Top Places to Visit in Ayodhya with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Ram Mandir",
    "description": "The newly constructed Ram Mandir is Ayodhya’s most sacred temple, dedicated to Lord Rama. Built with pink sandstone and Nagara-style architecture, it reflects divine grandeur. Pilgrims from across the world visit to witness this historic temple. The sanctum houses the idol of Ram Lalla in child form. Illuminated at night, the temple looks breathtaking. Ram Mandir is Ayodhya’s eternal spiritual heart."
  },
  {
    "title": "Hanuman Garhi",
    "description": "Hanuman Garhi is a famous temple dedicated to Lord Hanuman, located on a hilltop in Ayodhya. Devotees climb 76 steps to reach the shrine, believed to protect Ayodhya. The temple offers panoramic views of the city. Festivities during Ram Navami and Diwali make it vibrant. Pilgrims believe prayers here remove obstacles. Hanuman Garhi is Ayodhya’s divine guardian temple."
  },
  {
    "title": "Kanak Bhawan",
    "description": "Kanak Bhawan, also known as Sone-ka-Ghar, is a temple dedicated to Lord Rama and Goddess Sita. The idols here are adorned with golden ornaments, gifted by Queen Kaikeyi. The temple’s interiors are beautifully decorated with paintings and carvings. Pilgrims feel deep devotion in its serene ambiance. Festivals like Vivah Panchami are celebrated with grandeur. Kanak Bhawan is Ayodhya’s golden abode of faith."
  },
  {
    "title": "Saryu River Ghats",
    "description": "The ghats of the holy Saryu River are central to Ayodhya’s spiritual life. Devotees take sacred dips, especially during Kartik Purnima and Ram Navami. Evening aartis with lamps create a mesmerizing sight. Boating on the river offers peace and scenic views. The ghats are always filled with chants and rituals. Saryu Ghats are Ayodhya’s sacred riverfront of devotion."
  },
  {
    "title": "Treta Ke Thakur",
    "description": "Treta Ke Thakur Temple is believed to stand where Lord Rama performed the Ashwamedha Yajna. It houses idols of Lord Rama, Sita, Lakshman, and Hanuman carved from a single black stone. The temple opens only on special occasions, attracting thousands. Its connection to epic events makes it unique. Pilgrims feel divine presence here. Treta Ke Thakur is Ayodhya’s historic spiritual shrine."
  },
  {
    "title": "Nageshwarnath Temple",
    "description": "Nageshwarnath Temple, dedicated to Lord Shiva, is said to have been established by Kush, son of Lord Rama. It is one of Ayodhya’s oldest temples, attracting devotees of both Shiva and Rama. The temple plays a key role during Shivratri festivities. Its architecture blends history with faith. Pilgrims include it in their city darshan. Nageshwarnath is Ayodhya’s symbol of devotion to Shiva."
  },
  {
    "title": "Dashrath Mahal",
    "description": "Dashrath Mahal, located near Hanuman Garhi, is believed to be the royal palace of King Dashrath, father of Lord Rama. Today it houses idols of Lord Rama, Sita, Lakshman, and Bharat. The palace is decorated with colorful paintings and mirrors. Devotees feel as if they are entering the Ramayana era. Cultural programs are often held here. Dashrath Mahal is Ayodhya’s royal devotional landmark."
  },
  {
    "title": "Guptar Ghat",
    "description": "Guptar Ghat on the Saryu River is believed to be the place where Lord Rama took Jal Samadhi. The ghat is peaceful and serene, ideal for meditation and reflection. Temples like Chakrahari Shrine stand nearby. Evening aartis enhance its spiritual ambiance. Pilgrims visit to pay homage to Lord Rama’s final journey. Guptar Ghat is Ayodhya’s sacred site of moksha."
  },
  {
    "title": "Tulsi Smarak Bhawan",
    "description": "Tulsi Smarak Bhawan is dedicated to Goswami Tulsidas, the saint who wrote the Ramcharitmanas. It houses a research center, library, and museum on his life and works. Ramleela performances are regularly staged here. Visitors learn about Ayodhya’s literary and devotional heritage. Scholars and devotees gather for cultural events. Tulsi Smarak Bhawan is Ayodhya’s cultural center of devotion."
  },
  {
    "title": "Mani Parbat",
    "description": "Mani Parbat is a small hillock in Ayodhya associated with Lord Hanuman. Legends say it is a piece of the Sanjeevani mountain that fell here. The site offers a panoramic view of Ayodhya city. Temples dedicated to Lord Hanuman and Lord Rama stand on the hill. It is popular for meditation and spiritual reflection. Mani Parbat is Ayodhya’s mythological landmark of faith."
  }
],


                 "services": [
    {
      "name": "Pune to Ayodhya Cab",
      "description": "Experience comfortable and reliable travel with our Pune to Ayodhya Cab service, offering well-maintained vehicles and professional drivers for your long-distance journey."
    },
    {
      "name": "Pune to Ayodhya Taxi",
      "description": "Our Pune to Ayodhya Taxi service ensures safe and timely transportation with courteous drivers, perfect for pilgrims, tourists, and business travelers alike."
    },
    {
      "name": "Book Pune to Ayodhya Cab Package",
      "description": "Book comprehensive Pune to Ayodhya Cab Packages tailored for pilgrimage trips, family tours, or group travel with competitive pricing and convenient options."
    },
    {
      "name": "Pune to Ayodhya Taxi Fare",
      "description": "Get transparent and affordable Pune to Ayodhya Taxi Fare details upfront, so you can plan your trip with confidence and no hidden charges."
    },
    {
      "name": "Pune to Ayodhya Pilgrimage Cab",
      "description": "Travel with ease on your spiritual journey using our Pune to Ayodhya Pilgrimage Cab service, designed to offer comfort, safety, and punctuality for devotees."
    },
    {
      "name": "Pune to Ayodhya One Way Taxi",
      "description": "Choose our Pune to Ayodhya One Way Taxi for cost-effective, single-direction travel, ideal for pilgrims and travelers with one-way itineraries."
    },
    {
      "name": "Cab from Pune to Ayodhya",
      "description": "Reliable Cab from Pune to Ayodhya service featuring professional drivers and comfortable vehicles to make your long-distance travel hassle-free."
    },
    {
      "name": "Pune to Ayodhya Outstation Taxi Service",
      "description": "Our Pune to Ayodhya Outstation Taxi Service provides spacious vehicles, experienced drivers, and efficient routes for a smooth intercity journey."
    },
    {
      "name": "Ayodhya to Pune Cab",
      "description": "Plan your return trip with our Ayodhya to Pune Cab service offering timely pickups, comfortable rides, and professional drivers for a safe journey back."
    },
    {
      "name": "Pune to Ayodhya Travel by Car",
      "description": "Explore flexible travel options with our Pune to Ayodhya Travel by Car service, including both self-drive and chauffeur-driven vehicles."
    },
    {
      "name": "Pune to Ayodhya Family Cab Package",
      "description": "Enjoy comfortable family trips with our Pune to Ayodhya Family Cab Package, featuring spacious cars, safety features, and affordable rates for groups of all sizes."
    }
  ],
  "tableData": [
    ["Pune to Ayodhya Cab", "Pune to Ayodhya Taxi"],
    ["Book Pune to Ayodhya Cab Package", "Pune to Ayodhya Taxi Fare"],
    ["Pune to Ayodhya Pilgrimage Cab", "Pune to Ayodhya One Way Taxi"],
    ["Cab from Pune to Ayodhya", "Pune to Ayodhya Outstation Taxi Service"],
    ["Ayodhya to Pune Cab", "Pune to Ayodhya Travel by Car"],
    ["Pune to Ayodhya Family Cab Package", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Pune to Ayodhya Cab Packages",
    "WhyChoosedescription": "Platinum24 Cabs offers trusted and comfortable cab packages for your journey from Pune to Ayodhya, ensuring a smooth and pleasant travel experience."
  },
  {
    "WhyChooseheading": "Variety of Vehicles for All Group Sizes",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and tempo travellers to suit your group size and preferences for Pune to Ayodhya trips."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Cabs for Safe Travel",
    "WhyChoosedescription": "All vehicles are regularly cleaned and sanitized to provide a safe and hygienic environment throughout your Pune to Ayodhya journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Routes",
    "WhyChoosedescription": "Our skilled drivers know the best routes between Pune and Ayodhya to ensure timely and comfortable travel."
  },
  {
    "WhyChooseheading": "Affordable Packages with No Hidden Charges",
    "WhyChoosedescription": "Enjoy transparent pricing for Pune to Ayodhya cab packages that include tolls, fuel, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist you with your Pune to Ayodhya cab package bookings."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages Tailored to Your Needs",
    "WhyChoosedescription": "Choose from hourly, daily, or long-term cab packages customized for your Pune to Ayodhya travel."
  },
  {
    "WhyChooseheading": "Easy Online Booking with Instant Confirmation",
    "WhyChoosedescription": "Book your Pune to Ayodhya cab package quickly and securely through our website or app with immediate confirmation."
  }
]





















    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer Pune to Ayodhya cab packages?',
        answer: 'Yes, Platinum24 Cabs provides customized and affordable cab packages from Pune to Ayodhya to suit your travel needs.',
    },
    {
        question: 'How can I book Pune to Ayodhya cab packages?',
        answer: 'You can book through our website, mobile app, or by contacting our 24x7 customer support team for personalized assistance.',
    },
    {
        question: 'What types of vehicles are available in Pune to Ayodhya cab packages?',
        answer: 'Our packages include options for hatchbacks, sedans, SUVs, and luxury cars depending on your preferences and group size.',
    },
    {
        question: 'Are one-way and round-trip Pune to Ayodhya cab packages available?',
        answer: 'Yes, we offer both one-way and round-trip packages tailored to your itinerary.',
    },
    {
        question: 'Are the drivers experienced for long-distance travel like Pune to Ayodhya?',
        answer: 'Absolutely, our drivers are licensed, professional, and familiar with the Pune to Ayodhya route.',
    },
    {
        question: 'Can I customize pickup and drop-off points within Pune and Ayodhya?',
        answer: 'Yes, you can specify your preferred pickup and drop-off locations to maximize convenience.',
    },
    {
        question: 'What safety and hygiene standards are followed for Pune to Ayodhya cabs?',
        answer: 'All vehicles are regularly sanitized, and drivers adhere to strict safety and hygiene protocols throughout the journey.',
    },
    {
        question: 'Is Pune to Ayodhya cab service available 24x7?',
        answer: 'Yes, Platinum24 Cabs offers 24x7 booking and service availability for Pune to Ayodhya cab packages.',
    },
    {
        question: 'What payment methods are accepted for Pune to Ayodhya cab packages?',
        answer: 'We accept cash, UPI, digital wallets, and major credit/debit cards for smooth transactions.',
    },
    {
        question: 'Are there flexible packages for Pune to Ayodhya cab services?',
        answer: 'Yes, our packages can be customized according to your travel duration, stops, and preferences.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rajesh Kumar',
        feedback: 'The Pune to Ayodhya cab package was perfect for my pilgrimage trip. Comfortable car and friendly driver.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Anjali Verma',
        feedback: 'Highly satisfied with the Pune to Ayodhya cab service. Great flexibility and excellent customer support.',
        rating: 5,
    },
];











































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];






const puneToAyodhyaCabSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ayodhya Cab Packages",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-ayodhya-cab.jpg",
  "description": "Book Pune to Ayodhya cab packages with Platinum24 Cabs. Ideal for pilgrimage and family trips, choose from comfortable sedans, SUVs, and reliable outstation taxis. Affordable, safe, and available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "32150",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-ayodhya-cab-packages"
  }
};







    return (
        <div>

<Helmet>
  <title>Pune to Ayodhya Cab Packages | Pilgrimage & Family Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Ayodhya cab packages with Platinum24 Cabs. Ideal for pilgrimage and family trips, choose from comfortable sedans, SUVs, and reliable outstation taxis. Affordable, safe, and available 24/7."
  />
  <meta
    name="keywords"
    content="Pune to Ayodhya Cab, Pune to Ayodhya Taxi, Book Pune to Ayodhya Cab Package, Pune to Ayodhya Taxi Fare, Pune to Ayodhya Pilgrimage Cab, Pune to Ayodhya One Way Taxi, Cab from Pune to Ayodhya, Pune to Ayodhya Outstation Taxi Service, Ayodhya to Pune Cab, Pune to Ayodhya Travel by Car, Pune to Ayodhya Family Cab Package"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToAyodhyaCabSchema)}
  </script>
</Helmet>



            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/105.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoayoshyacabpackage;